import Preact, { Fragment, h } from "preact";

export const RouteLogo = ({ variant }) => {
  return variant === "default" ? (
    <>
      <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="route-logo-lg">
        <path d="M22 10.9483C19.0161 7.98697 16.2419 5.07693 13.2821 2.36018C11.7308 0.936203 10.2766 0.987482 8.60228 2.26922C7.11212 3.41032 5.78538 4.75539 4.20446 6.17345C6.80073 6.76845 8.32138 8.38185 9.87944 9.98548C11.3593 11.5081 12.9138 12.966 14.499 14.3843C15.649 15.4132 17.0124 15.3911 18.1699 14.4726C19.5308 13.3934 20.7356 12.1264 22 10.9483ZM1.41542 14.7775C3.14839 13.099 4.7955 11.5039 6.46126 9.89076C5.44818 8.15377 2.55883 8.11045 1.13725 9.4985C-0.172207 10.7771 -0.674994 13.2508 1.41542 14.7775V14.7775Z" fill="url(#paint0_linear_1987_31468)"/>
        <defs>
        <linearGradient id="paint0_linear_1987_31468" x1="22" y1="15.1589" x2="8.8061" y2="-3.38919" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2BFFFF"/>
        <stop offset="0.5" stop-color="#28B8E3"/>
        <stop offset="0.765241" stop-color="#278FB3"/>
        <stop offset="1" stop-color="#265F7B"/>
        </linearGradient>
        </defs>
      </svg>
      <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="route-logo-sm">
        <path d="M15 6.82838C12.9656 4.8093 11.074 2.82518 9.05601 0.97285C7.99827 0.00195465 7.00675 0.0369175 5.86519 0.910831C4.84917 1.68885 3.94458 2.60594 2.86668 3.57281C4.63686 3.97848 5.67367 5.07853 6.73598 6.17191C7.74494 7.2101 8.80485 8.20409 9.8857 9.17111C10.6698 9.87262 11.5994 9.85758 12.3886 9.23135C13.3164 8.4955 14.1379 7.63167 15 6.82838ZM0.96506 9.43919C2.14663 8.2948 3.26966 7.20723 4.4054 6.10734C3.71467 4.92302 1.74466 4.89349 0.775395 5.83988C-0.117414 6.71163 -0.460223 8.39829 0.96506 9.43919V9.43919Z" fill="url(#paint0_linear_1987_31481)"/>
        <defs>
        <linearGradient id="paint0_linear_1987_31481" x1="15" y1="9.69927" x2="6.00416" y2="-2.94718" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2BFFFF"/>
        <stop offset="0.5" stop-color="#28B8E3"/>
        <stop offset="0.765241" stop-color="#278FB3"/>
        <stop offset="1" stop-color="#265F7B"/>
        </linearGradient>
        </defs>
      </svg>    
    </>
  ) : (
    <svg
      width="17"
      height="11"
      viewBox="0 0 17 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 7.41684C14.3299 5.26315 12.3123 3.14676 10.1597 1.17094C9.03149 0.135321 7.97387 0.172614 6.7562 1.10479C5.67245 1.93468 4.70755 2.91291 3.55779 3.94423C5.44599 4.37695 6.55191 5.55034 7.68504 6.71661C8.76127 7.82401 9.89184 8.88427 11.0447 9.91576C11.8811 10.664 12.8726 10.648 13.7145 9.98001C14.7042 9.1951 15.5804 8.27368 16.5 7.41684ZM1.5294 10.2017C2.78974 8.98102 3.98764 7.82095 5.1991 6.64773C4.46231 5.38446 2.36097 5.35295 1.32709 6.36244C0.374759 7.2923 0.00909552 9.09141 1.5294 10.2017Z"
        fill="#31C8E0"
      />
    </svg>
  );
};
